export const sessionStorageGetItem = (key: string): string | null => {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const sessionStorageSetItem = (
  key: string,
  value: string | number,
): void => {
  try {
    if (typeof value === 'string') {
      sessionStorage.setItem(key, value);
    }
    if (typeof value === 'number') {
      sessionStorage.setItem(key, value.toString());
    }
  } catch (e) {
    console.error(e);
  }
};

export const sessionStorageRemoveItem = (key: string): void => {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.error(e);
  }
};

export const sessionStorageClear = (): void => {
  try {
    sessionStorage.clear();
  } catch (e) {
    console.error(e);
  }
};
